import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import TableActionButtonAtom from '../../../components/atoms/table-action-button/table-action-button';
import { HELP_MODES } from '../../../utils/constant';

const getTypeTableColumns = (t, onTypeEdit, onTypeDelete, helpMode = HELP_MODES.BASIC) => {
    return [
        {
            field: 'provided',
            headerName: t('provided'),
            unSortIcon: true,
        },
        {
            field: 'name',
            headerName: t('name'),
            unSortIcon: true,
        },
        {
            field: 'category.name',
            unSortIcon: true,
            headerName: t('category'),
        },
        {
            field: 'manufacturer.name',
            unSortIcon: true,
            headerName: t('manufacturer'),
        },
        {
            headerName: t('action'),
            sortable: false,
            maxWidth: 120,
            cellRenderer: (props) => {
                const {data, rowIndex} = props;
                return <div className="d-flex ag-action-cell">
                    <TableActionButtonAtom
                        t={t}
                        helpMode={helpMode}
                        icon={faEdit}
                        onClickAction={() => onTypeEdit(data, rowIndex)}
                        tooltipTitle='action-edit'
                    />
                    <TableActionButtonAtom
                        t={t}
                        helpMode={helpMode}
                        icon={faTrash}
                        className="mx-2"
                        onClickAction={() => onTypeDelete(data, rowIndex)}
                        tooltipTitle='action-delete'
                    />
                </div>
            }
        }
    ];
}

export {
    getTypeTableColumns
}